






































import { Component } from 'vue-property-decorator';
import ExpireTime from '@/components/ViewComponent/Issue/ExpireTime.vue';
import IssueStatusBtn from '@/components/ViewComponent/Issue/IssueStatusBtn.vue';
import IssueItemMixin from './issue-item.mixin';

@Component<IssueItemPc>({
  components: {
    IssueStatusBtn,
    ExpireTime,
  },
})
export default class IssueItemPc extends IssueItemMixin {}
